/**
 * Menu Vuex
 */
import * as API from "@/endpoints";
import Axios from "axios";
import _ from "lodash";
import Cons from "@/constants.json";
import route from "@/router";
import store from "@/store";

import axiosRetry from "axios-retry";

axiosRetry(Axios, { retries: 0 });

export default {
  namespaced: true,
  state: {
    packages: {},
    userStory: {},
    userStories: [],
    tracks: {
      pages: []
    },
    isLoadingElements: false,
    isLoadingDocuments: false,
    trackData: {
      elements: [],
      documents: []
    },
    isLoading: false,
    selectedTrackModule: [],
    myUserStory: {}
  },
  getters: {
    myStory: state => {
      return state.myUserStory;
    },
    isLoadingElements: state => {
      return state.isLoadingElements;
    },
    isLoadingDocuments: state => {
      return state.isLoadingDocuments;
    },
    trackData: state => {
      return state.trackData;
    },
    isLoadingElements: state => {
      return state.isLoadingElements;
    },
    isLoadingLibrary: state => {
      return state.isLoading;
    },
    myTracks: state => {
      return state.tracks;
    },
    myUserStories: state => {
      return state.userStories;
    },
    selectedTrackModules: state => {
      return state.selectedTrackModule;
    }
  },
  mutations: {
    setLoader(state, payload) {
      state.isLoading = payload;
    },
    setPackages(state, payload) {
      state.packages = payload;
    },
    setUserStory(state, payload) {
      state.userStory = payload;
    },
    setUserStories(state, payload) {
      state.userStories = payload;
    },
    setUserStoryTracks(state, payload) {
      state.tracks = payload;
    },
    setSelectedTrackModules(state, payload) {
      state.selectedTrackModule = payload;
    },
    setDocuments(state, payload) {
      state.trackData.documents = payload;
    }
  },
  actions: {
    getSearchResult({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(
          `${API.endpoints.base}table-of-contents/${payload.userStory}?keyword=${payload.keyword}`
        )
          .then(res => {
            resolve(res.data);
          })
          .catch(e => {
            reject(e.response);
          });
      });
    },
    getUserStories({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        commit("setLoader", true);
        commit("base/setLoadingPage", 1, { root: 1 });
        Axios.get(
          `${API.endpoints.base}/brand/${Cons[0].BRAND_ID}/user/stories`,
          {
            "axios-retry": {
              retries: 3
            }
          }
        ).then(
          res => {
            // console.log("USER STORIES: ", res.data)

            commit("setUserStories", res.data);
            console.log("setUserStories", res.data);

            if (res.data && res.data.length > 0) {
              commit("setUserStory", res.data[0]);
              commit(
                "brand/setSelectedStory",
                res.data.length >= 1 ? res.data[0].id : null,
                {
                  root: 1
                }
              );
              dispatch("getPlanInfo", res.data[0].id)
                .then(res => {
                  console.log("getPlanInfo", res);
                  commit("setUserStoryTracks", res);
                  commit("base/setLoadingPage", 0, { root: 1 });
                  commit("setLoader", false);

                  resolve(res.data);
                })
                .catch(err => {
                  dispatch("exceptionHandling", { _err: err }, { root: 1 });
                  commit("base/setLoadingPage", 0, { root: 1 });
                  commit("setLoader", false);
                  reject(err)
                });
            } else {
              // no stories, just skip
              // if (
              //   (_.get(store, "state.user.info.email") &&
              //     store.state.user.info.email.length > 0) ||
              //   (_.get(store, "state.user.info.mobile") &&
              //     store.state.user.info.mobile.length > 0)
              // ) {
              //   route.replace("/onboarding?skip_user_info_verification=true");
              // }
              
              commit("base/setLoadingPage", 0, { root: 1 });
              resolve(res.data);
            }
          },
          error => {
            commit("setLoader", false);
            commit("base/setLoadingPage", 0, { root: 1 });
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    },
    async getModuleElements({ state, commit, dispatch }, payload) {
      try {
        let res = await Axios.get(API.endpoints.base + "userstory/" + payload, {
          "axios-retry": {
            retries: 3
          }
        });
        return Promise.resolve(res.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getPlanInfo({ state, commit, dispatch, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit("base/setLoadingPage", 1, { root: 1 });
        commit("setLoader", true);
        Axios.get(API.endpoints.base + "userstory/" + payload, {
          "axios-retry": {
            retries: 3
          }
        }).then(
          res => {
            if (rootState.brand.selectedStory == payload) {
              console.log("SELECTED USER STORY: ", res.data.title);
              state.myUserStory = res.data;
            }

            if (
              (!_.get(res, "data.id") ||
                (!_.get(res, "data.subscribed") &&
                  res.data.parent_id ==
                    rootState.user.brand.default_package_id)) &&
              ((_.get(store, "state.user.info.email") &&
                store.state.user.info.email.length > 0) ||
                (_.get(store, "state.user.info.mobile") &&
                  store.state.user.info.mobile.length > 0))
            ) {
              // fix for user being redirected to story selection page while in onboarding
              if (route.history.current.name !== "OnBoarding-Brand")
                route.replace("/onboarding?skip_user_info_verification=true");
            }

            resolve(res.data);
            commit("base/setLoadingPage", 0, { root: 1 });
            commit("setLoader", false);
          },
          error => {
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
            commit("base/setLoadingPage", 0, { root: 1 });
            commit("setLoader", false);
          }
        );

        // Axios.get(API.endpoints.careplan + '/' + payload)
        //   .then(res => {
        //     resolve(res.data)
        //     commit("setLoader", false);
        //   }, error => {
        //     dispatch('exceptionHandling', { _err: error }, { root: 1 })
        //     commit("setLoader", false);
        //     reject(error)
        //   })
      });
    },
    async getModuleItems(context, payload) {
      try {
        context.state.isLoadingElements = true;
        let res = await Axios.get(
          `${API.endpoints.base}/careplan/${payload}?visit=1`,
          {
            "axios-retry": {
              retries: 3
            }
          }
        );
        context.state.trackData.elements = res.data.pages;
        context.state.isLoadingElements = false;
        return res;
      } catch (e) {
        context.state.isLoadingElements = false;
        console.log(e);
      }
    },
    getTrackModules({ commit, dispatch }, careplanIds) {
      commit("setSelectedTrackModules", []);
      commit("base/setLoadingPage", 1, { root: 1 });
      commit("setLoader", true);
      return new Promise((resolve, reject) => {
        Axios.get(
          API.endpoints.careplan +
            "/in/range/compiled?careplan_ids=" +
            careplanIds,
          {
            "axios-retry": {
              retries: 3
            }
          }
        ).then(
          res => {
            commit("setSelectedTrackModules", res.data);
            commit("base/setLoadingPage", 0, { root: 1 });
            commit("setLoader", false);
            resolve(res.data);
          },
          error => {
            commit("base/setLoadingPage", 0, { root: 1 });
            commit("setLoader", false);
            dispatch("exceptionHandling", { _err: error }, { root: 1 });
            reject(error);
          }
        );
      });
    }
  }
};
